import { axios, BaseApiUrl } from '../axios_config';

// 列表
export const getSignList = params => {
    return axios.post(`${BaseApiUrl}/TFMobile/GetTFPutOnList`, { ...params }).then(res => res.data)
}

// 明细
export const getDeliveryNo = params => {
    return axios.get(`${BaseApiUrl}/TFMobile/GetPutOnByBatchCode`, { params }).then(res => res.data);
}

// 签收
export const submitSignFor = params => {
    return axios.post(`${BaseApiUrl}/TFMobile/InsertTFPutOnStock`, { ...params }).then(res => res.data);
}

